import React, { useEffect, useState } from "react";
import Layout from "../../../Layout";
import { Link, Outlet, useNavigate } from "react-router-dom";
import ReactCountryFlag from "react-country-flag";
import { getName } from "country-list";
import { Skeleton } from "primereact/skeleton";
import EmployeeSideBar from "./EmployeeSideBar";
import useEditEmployee from "../actions/useEditEmployee";
import { useSelector } from "react-redux";

const EditEmployee = () => {
  const { employeeDetails, isDataAvailable } = useEditEmployee();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const entityData = useSelector((state) => state.globalEntities.entity_detail);

  useEffect(() => {
    if (entityData) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [entityData]);

  const breadcrumbs = [
    {
      label: <span className="breadcrumb-link">My Entities</span>,
      command: () => navigate("/entities"),
      id: "entities",
    },
    {
      label: (
        <Link
          to={`/entity/${entityData?.id}/dashboard`}
          className="link__style flex"
        >
          {isDataAvailable && !loading ? (
            entityData?.name
          ) : (
            <Skeleton width="100px" height="20px" className="mr-1" />
          )}
          {isDataAvailable && !loading ? (
            " "
          ) : (
            <Skeleton width="10px" height="20px" className="mr-1" />
          )}
          {isDataAvailable && !loading && entityData ? (
            <>
              (
              <ReactCountryFlag
                countryCode={entityData?.country || ""}
                svg
                className=""
              />{" "}
              {getName(entityData?.country || "")})
            </>
          ) : (
            <Skeleton width="150px" height="20px" className="mr-1" />
          )}
        </Link>
      ),
      id: "entity",
    },
    {
      label: <span className="breadcrumb-link">Employee Registry</span>,
      command: () => navigate(`/entity/${entityData?.id}/employee`),
      id: "Employee Registry",
    },
    {
      label: (
        <>
          {isDataAvailable && !loading ? (
            `${employeeDetails?.name} ${employeeDetails?.last_name}`
          ) : (
            <Skeleton width="100px" height="20px" className="mr-1" />
          )}
        </>
      ),
    },
  ];

  return (
    <Layout crumbs={breadcrumbs}>
      <div className="grid grid-nogutter edit__employee__container">
        <div className="col-12 Entities-container">
          <div className="grid">
            <div className="col-3">
              <EmployeeSideBar
                employeeDetails={employeeDetails}
                isDataAvailable={isDataAvailable}
              />
            </div>
            <div className="col-9">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default EditEmployee;
